import { useState } from 'react';

export default function WhatsAppFloat() {
  const [hovered, setHovered] = useState(false);
  const phoneNumber = '919541399210';
  const message = encodeURIComponent('Hi! I would like to know more about your products at Pets Valley.');

  return (
    <div className="whatsapp-float-container" data-testid="whatsapp-float">
      {/* Tooltip */}
      <div className={`whatsapp-tooltip ${hovered ? 'whatsapp-tooltip-visible' : ''}`}>
        Chat with us! 💬
      </div>

      {/* Button */}
      <a
        href={`https://wa.me/${phoneNumber}?text=${message}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float-btn"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-btn"
      >
        {/* WhatsApp SVG Icon */}
        <svg viewBox="0 0 32 32" className="whatsapp-icon" fill="currentColor">
          <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.96A15.89 15.89 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.302 22.602c-.39 1.1-1.932 2.014-3.174 2.28-.852.18-1.964.324-5.71-1.228-4.796-1.986-7.882-6.85-8.122-7.166-.23-.318-1.932-2.572-1.932-4.906 0-2.332 1.222-3.476 1.656-3.952.39-.432.924-.614 1.234-.614.15 0 .284.008.406.014.434.02.652.044 .938.726.358.854 1.228 3.002 1.336 3.222.108.22.216.514.086.808-.12.3-.228.434-.448.688-.22.254-.428.448-.648.722-.2.24-.424.494-.174.928.25.434 1.114 1.838 2.392 2.978 1.644 1.466 3.028 1.92 3.46 2.134.434.214.688.18.942-.108.26-.294 1.106-1.286 1.4-1.728.29-.434.584-.362.982-.218.4.15 2.544 1.2 2.978 1.418.434.22.724.324.832.508.108.18.108 1.066-.282 2.166z"/>
        </svg>

        {/* Pulse rings */}
        <span className="whatsapp-pulse-ring"></span>
        <span className="whatsapp-pulse-ring whatsapp-pulse-ring-2"></span>
      </a>
    </div>
  );
}
